import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { predictionFeaturedMarketsDataProvider } from './dataProvider';

export function initPredictionFeaturedMarketsDataProvider() {
  registerModuleDataProvider(Resources.predictionFeaturedMarkets, predictionFeaturedMarketsDataProvider);
  registerModuleDataProvider(Resources.predictionFeaturedMarketsMarkets, predictionFeaturedMarketsDataProvider);
  registerModuleDataProvider(Resources.predictionFeaturedMarketsEvents, predictionFeaturedMarketsDataProvider);
}

initPredictionFeaturedMarketsDataProvider();
